import { render, staticRenderFns } from "./profile.vue?vue&type=template&id=1f0b3e62&"
import script from "./profile.vue?vue&type=script&lang=ts&"
export * from "./profile.vue?vue&type=script&lang=ts&"
import style0 from "./profile.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports